import { createSelector } from 'reselect'
import { pagesSelector } from '../selectors'

export const investmentsPageSelector = createSelector(pagesSelector, pages => pages.investmentsPage)
